<div class="table-responsive">
    <table class="table table-striped table-borderless"  *ngIf="trips != null">
      <tbody>
        <tr *ngFor="let trip of trips ; let i=index" class="mis-viajes-clickeable" [ngClass]="{'mis-viajes-selected': (selectedTrip == trip)}" (click)="onSelectRoute(trip)">
          <td><img class="table-img" src="/assets/img/sura-icon-route-blue.svg" alt="SURA ICON RUTA"/></td>
          <td><span id="horaInicio">{{ trip.startTime }}</span><br/><span id="horaTermino">{{ trip.endTime }}</span></td>
          <td><span id="tiempo">{{ trip.drivingTime }} min.</span></td>
          <td><span id="kms">{{ trip.distanceTraveled }} Kms</span></td>
          <td><span><strong id="gasto">{{ trip.spended | currency:"CLP":"$":0:'es_CL' }}</strong></span></td>
        </tr>
      </tbody>
    </table>
  </div>